<template>
  <div>
    <div class="studentInfoWrap" v-show="isLimit">
      <div class="studentInfoEnter">
        <h4>学员信息</h4>
        <div class="input_info">
          <div class="input-info-item">
            <span>学员姓名</span>
            <dl class="flex-right-input">
              <input type="text" placeholder="请输入" v-model="ruleForm.studentName" ref="studentName" @focus="clearInput" />
              <p class="error_text">请输入学员姓名</p>
            </dl>
          </div>
          <div class="input-info-item">
            <span>电话</span>
            <dl class="flex-right-input">
              <input type="tel" placeholder="请输入" v-model="ruleForm.studentTel" maxlength="11" ref="studentTel" @focus="clearInput" />
              <p class="error_text">请输入电话，QQ，微信至少一项</p>
            </dl>
          </div>
          <div class="input-info-item">
            <span>QQ</span>
            <dl class="flex-right-input">
              <input type="tel" placeholder="请输入" v-model="ruleForm.studentQQ" ref="studentQQ" @focus="clearInput" />
              <p class="error_text">请输入电话，QQ，微信至少一项</p>
            </dl>
          </div>
          <div class="input-info-item">
            <span>微信</span>
            <dl class="flex-right-input">
              <input
                type="text"
                placeholder="请输入"
                v-model="ruleForm.studentWechar"
                ref="studentWechar"
                @focus="clearInput"
              />
              <p class="error_text">请输入电话，QQ，微信至少一项</p>
            </dl>
          </div>
          <div class="input-info-item">
            <span>类型</span>
            <dl
              class="flex-right-input"
              @click="
                showPickerSource = true;
                clearInput();
              "
            >
              <input type="text" placeholder="请选择" readonly v-model="ruleForm.networkSource" />
              <van-icon name="arrow-down" ref="networkSource" />
              <p class="error_text">请选择类型</p>
            </dl>
          </div>
          <div class="input-info-item">
            <span>咨询渠道</span>
            <dl
              class="flex-right-input"
              @click="
                showPickerNetwork = true;
                clearInput();
              "
            >
              <input type="text" placeholder="请选择" readonly v-model="ruleForm.sourcePlace" />
              <van-icon name="arrow-down" ref="sourcePlace" />
              <p class="error_text">请选择咨询渠道</p>
            </dl>
          </div>
          <div class="input-info-item">
            <span @click="showMess = true"> 学员质量 <i class="el-icon-question"></i> </span>
            <dl
              class="flex-right-input"
              @click="
                showPickerQulity = true;
                clearInput();
              "
            >
              <input type="text" placeholder="请选择" readonly v-model="ruleForm.studentQulity" />
              <van-icon name="arrow-down" ref="studentQulity" />
              <p class="error_text">请选择学员质量</p>
            </dl>
          </div>
          <div class="input-info-item">
            <span>指定咨询师</span>
            <dl
              class="flex-right-input"
              @click="
                showPickerZkName = true;
                clearInput();
              "
            >
              <input type="text" placeholder="请选择" readonly v-model="ruleForm.zkName" />
              <van-icon name="arrow-down" ref="zkName" />
              <p class="error_text">请选择指定咨询师</p>
            </dl>
          </div>
        </div>
      </div>
      <!-- <div class="submit_fixed">
        <span @click="resetForm">重置</span>
        <span @click="ensureSubmit">确认</span>
      </div> -->
      <div class="fixed_bottom fixed_horizo_center">
        <div class="button_bottom">
          <dl @click="resetForm">取消</dl>
          <dl @click="ensureSubmit">确认</dl>
        </div>
      </div>
      <!--咨询渠道-->
      <van-popup v-model="showPickerNetwork" round position="bottom" :lock-scroll="false">
        <div class="select_border">
          <header>
            <span @click="emptySelect">清空</span>
            <span @click="completeNetwork">完成</span>
          </header>
          <div class="flex-center margin-bot">
            <van-search class="flex1" v-model="networkSourceString" placeholder="搜索渠道" @clear="searchNetwork" />
            <span class="search-text" @click="searchNetwork">搜索</span>
          </div>
          <van-radio-group v-model="networkSource" class="specialRadio">
            <van-cell-group>
              <van-cell v-for="item in resetSourcePlace" :key="item.did" clickable @click="networkSource = JSON.stringify(item)">
                <template #title>
                  <div class="flex-user">
                    <span>{{ item.dname }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="JSON.stringify(item)" />
                </template>
              </van-cell>
              <!--          </lazy-component>-->
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>

      <!--指定咨询师-->
      <van-popup v-model="showPickerZkName" round position="bottom">
        <div class="select_border">
          <header>
            <span @click="emptySelect">清空</span>
            <span @click="completeZkName">完成</span>
          </header>
          <div class="flex-center margin-bot">
            <van-search class="flex1" v-model="zkNameString" placeholder="搜索咨询师" @clear="searchZkName" />
            <!--          <span class="search-text" @click="searchZkName">搜索</span>-->
          </div>
          <van-radio-group v-model="zkName" class="specialRadio">
            <van-cell-group>
              <van-cell v-for="item in resetZkNameList" :key="item.id" clickable @click="zkName = JSON.stringify(item)">
                <template #title>
                  <div class="flex-user">
                    <span>{{ item.name }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <lazy-component>
                    <van-radio :name="JSON.stringify(item)" />
                  </lazy-component>
                </template>
              </van-cell>
              <!--          </lazy-component>-->
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>

      <!--学员质量-->
      <van-popup v-model="showPickerQulity" round position="bottom">
        <div class="select_border">
          <header>
            <span @click="emptySelect">清空</span>
            <span @click="completeQulity">完成</span>
          </header>
          <van-radio-group v-model="selectQulity">
            <van-cell-group>
              <van-cell v-for="item in studentQulity" :key="item.did" clickable @click="selectQulity = JSON.stringify(item)">
                <template #title>
                  <div class="flex-user">
                    <span>{{ item.dname }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="JSON.stringify(item)" />
                </template>
              </van-cell>
              <!--          </lazy-component>-->
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>

      <!--网络来源渠道-->
      <van-popup v-model="showPickerSource" round position="bottom">
        <div class="select_border">
          <header>
            <span @click="emptySelect">清空</span>
            <span @click="completeSourceWay">完成</span>
          </header>
          <van-radio-group v-model="sourceWay">
            <van-cell-group>
              <van-cell v-for="item in sourceArea" :key="item.did" clickable @click="sourceWay = JSON.stringify(item)">
                <template #title>
                  <div class="flex-user">
                    <span>{{ item.dname }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="JSON.stringify(item)" />
                </template>
              </van-cell>
              <!--          </lazy-component>-->
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>
    </div>
    <emptyPage :isLimit="isLimit" />
    <van-dialog v-model="showMess" title="学员质量规则">
      <div class="show-quality">
        <p>
          <span class="qe-title"> A量：</span>
          <span class="qe-text">了解培训/接受学习/学习意向量/年龄学历相符；</span>
        </p>
        <p>
          <span class="qe-title"> B量：</span>
          <span class="qe-text">有转行想法/有学习规划/正在了解或学习相关视频 ；</span>
        </p>

        <p><span class="qe-title"> C量：</span><span class="qe-text">已建立联系/不排斥沟通/需要长期影响（已加微信/QQ）/低年级大学生；</span></p>
        <p><span class="qe-title"> D量：</span><span class="qe-text">暂时联系不上/无效联系方式/排斥培训/排斥沟通/广告商/骂人的/年龄不符/无千锋相关学科且学科跨度大/竞品；</span></p>
        <p>注：学员只能从D量往A量升级，不能降级</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { studentQwInitAddForInfoFlow, studentQwAddForInfoFlow, getSqAdminListAll } from "@/server/api.js";
import { Toast } from "vant";
import { wxConfig } from "../fastReply/js/config";
import { pageLimit, wefunstatistics } from "@/utils/public";
import emptyPage from "@/components/emptyPage";

export default {
  name: "enterInfo",
  data() {
    return {
      sourcePlace: [], //初始化来源渠道列表
      zkNameList: [], //初始化咨询师列表
      resetSourcePlace: [], //
      resetZkNameList: [],
      showMess: false,

      studentQulity: [], //学员质量列表
      sourceArea: [], //来源渠道列表
      networkSourceList: [], //网络来源arr
      defaultIndexSource: 0,
      showPickerNetwork: false, //网络来源开关
      showPickerZkName: false, //指定咨询师开关
      showPickerQulity: false, //指定学员质量开关
      showPickerSource: false, //指定来源渠道开关
      networkSourceString: "", //搜索网络来源关键词
      zkNameString: "", //搜索咨询师关键词

      networkSource: "", //单选网络来源渠道
      zkName: "", //单选指定咨询师
      selectQulity: "", //单选学员质量
      sourceWay: "", //单选来源渠道
      ruleForm: {
        studentName: "",
        studentTel: "",
        studentQQ: "",
        studentWechar: "",
        networkSource: "学员咨询",
        sourcePlace: "",
        studentQulity: "",
        zkName: "",
        externalUserId: "",
      },
      isLimit: "",
      jsList: ["getCurExternalContact"],
      windowurl: window.location.href.split("#")[0],
    };
  },
  components: {
    emptyPage,
  },
  async created() {
    let that = this;
    await pageLimit("student:qwAddForInfoFlow", function (bool) {
      that.isLimit = bool;
    });
    if (this.isLimit) {
      await wefunstatistics("14", window.location.href.split("#")[0]);
      wxConfig(this.windowurl, this.jsList).then(() => {
        wx.invoke("getCurExternalContact", {}, function (res) {
          if (res.userId) {
            that.ruleForm.externalUserId = res.userId;
          }
        });
      });
      await this.getSqAdminList();
      await this.getSoureZkName();
    }
  },
  watch: {
    networkSourceString() {
      this.searchNetwork();
    },
    zkNameString() {
      this.searchZkName();
    },
  },
  methods: {
    //来源渠道，咨询师列表
    async getSoureZkName() {
      let res = await studentQwInitAddForInfoFlow();
      if (res.code !== "200") return Toast.fail(res.msg);
      this.sourceArea = res.data.onlineSourcesList;
      for (let i of this.sourceArea) {
        if (i.dname === "学员咨询") {
          this.sourceWay = JSON.stringify(i);
        }
      }
      this.resetSourcePlace = this.sourcePlace = res.data.askfromList;
      this.studentQulity = res.data.zhiliangList.reverse();
    },

    async getSqAdminList() {
      let res = await getSqAdminListAll({});
      if (res.code !== "200") return Toast.fail(res.msg);
      this.resetZkNameList = [...res.data];
      this.zkNameList = res.data;
      //alert(JSON.stringify(this.resetZkNameList));
    },

    //搜索咨询师
    searchZkName() {
      if (!this.zkNameString) return (this.resetZkNameList = this.zkNameList);
      this.resetZkNameList = this.zkNameList.filter((item) => {
        return item.name.indexOf(this.zkNameString) !== -1;
      });
    },
    //搜索来源渠道
    searchNetwork() {
      if (!this.networkSourceString) return (this.resetSourcePlace = this.sourcePlace);
      this.resetSourcePlace = this.sourcePlace.filter((item) => {
        return item.dname.indexOf(this.networkSourceString) !== -1;
      });
    },

    //提交
    async ensureSubmit() {
      if (!this.ruleForm.studentName) return (this.$refs.studentName.nextElementSibling.style.display = "block");
      //   !this.ruleForm.studentTel &&
      // !this.ruleForm.studentQQ &&
      // !this.ruleForm.studentWechar
      if (!this.ruleForm.studentTel && !this.ruleForm.studentQQ && !this.ruleForm.studentWechar) {
        this.$refs.studentTel.nextElementSibling.style.display = "block";
        this.$refs.studentWechar.nextElementSibling.style.display = "block";
        this.$refs.studentQQ.nextElementSibling.style.display = "block";
        return;
      }
      if (!this.ruleForm.networkSource) return (this.$refs.networkSource.nextElementSibling.style.display = "block");
      if (!this.ruleForm.sourcePlace) return (this.$refs.sourcePlace.nextElementSibling.style.display = "block");
      if (!this.ruleForm.studentQulity) return (this.$refs.studentQulity.nextElementSibling.style.display = "block");
      if (!this.ruleForm.zkName) return (this.$refs.zkName.nextElementSibling.style.display = "block");

      let res = await studentQwAddForInfoFlow({
        name: this.ruleForm.studentName,
        phone: this.ruleForm.studentTel,
        weixin: this.ruleForm.studentWechar,
        //weixin: "",
        qq: this.ruleForm.studentQQ,
        askfrom: JSON.parse(this.networkSource).did, //来源渠道
        type: JSON.parse(this.sourceWay).did, //网络来源
        zhiliang: JSON.parse(this.selectQulity).did,
        zid: JSON.parse(this.zkName).id,
        externalUserId: this.ruleForm.externalUserId,
      });
      if (res.data.code !== "200") return Toast.fail(res.data.msg);
      if (res.data.data.isRepeat == 0) {
        this.$notify({ type: "success", message: "新量已入库" });
      } else if (res.data.data.isRepeat == 1 && res.data.data.isLibrary == 1) {
        this.$notify({ type: "success", message: "重量已入库" });
      } else if (res.data.data.isRepeat == 1 && res.data.data.isLibrary == 0) {
        this.$notify({ type: "danger", message: "重量不符合入库规则" });
      }
      //
      await this.$router.push("/index");
      // this.resetForm();
    },

    clearInput() {
      let input = document.querySelectorAll(".error_text");
      for (let i of input) {
        i.style.display = "none";
      }
    },

    //重置
    resetForm() {
      this.networkSource = "";
      this.zkName = "";
      this.selectQulity = "";
      this.sourceWay = "";
      Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
      this.clearInput();
    },

    //确认来源渠道
    completeNetwork() {
      this.showPickerNetwork = false;
      if (this.networkSource) {
        this.ruleForm.sourcePlace = JSON.parse(this.networkSource).dname;
      } else {
        this.ruleForm.networkSource = "";
      }
    },

    //确认咨询师
    completeZkName() {
      this.showPickerZkName = false;
      if (this.zkName) {
        this.ruleForm.zkName = JSON.parse(this.zkName).name;
      } else {
        this.ruleForm.zkName = "";
      }
    },

    //确认学员质量
    completeQulity() {
      this.showPickerQulity = false;
      if (this.selectQulity) {
        this.ruleForm.studentQulity = JSON.parse(this.selectQulity).dname;
      } else {
        this.ruleForm.studentQulity = "";
      }
    },

    //确认网络来源
    completeSourceWay() {
      this.showPickerSource = false;
      if (this.sourceWay) {
        this.ruleForm.networkSource = JSON.parse(this.sourceWay).dname;
      } else {
        this.ruleForm.networkSource = "";
      }
    },

    //清空选择
    emptySelect() {
      if (this.showPickerNetwork) {
        this.networkSource = "";
      } else if (this.showPickerZkName) {
        this.zkName = "";
      } else if (this.showPickerQulity) {
        this.selectQulity = "";
      } else {
        this.sourceWay = "";
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "css/enterInfo";
</style>
